import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";

import { renderCommentAvatar } from "../../../utils/helpers/ai-persona-avatars";

interface ImageCommentPinProps {
  comment: BaseTicketComment;
  isActive: boolean;
  onPinClick: (comment: BaseTicketComment) => void;
}

export function ImageCommentPin({
  comment,
  isActive,
  onPinClick,
}: ImageCommentPinProps) {
  const relX = comment.rel_x;
  const relY = comment.rel_y;
  if (relX == null || relY == null) return null;

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onPinClick(comment);
      }}
      className="absolute z-20 flex size-[25px] cursor-pointer items-center justify-center border-none transition-transform"
      style={{
        left: `${relX * 100}%`,
        top: `${relY * 100}%`,
        transform: `translate(-50%, -100%) ${isActive ? "scale(1.25)" : "scale(1)"}`,
        borderRadius: "20px 20px 20px 0",
        backgroundColor: comment.isRequired ? "var(--puntt-red-9)" : "#fff",
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
      }}
      title={comment.description?.slice(0, 80)}
    >
      <span className="flex size-[18px] items-center justify-center overflow-hidden [&_img]:size-[18px] [&_svg]:size-[18px]">
        {renderCommentAvatar(comment, true)}
      </span>
    </button>
  );
}
